import React from 'react';
import SobreNos from '../components/SobreNos';
import ProposicoesValores from '../components/ProposicoesValores';
import TimeMSA from '../components/TimeMSA';
import MarcosSucesso from '../components/MarcosSucesso';
import Footer from '../components/Footer';

function SobreNosPage() {
  return (
    <div>
      <SobreNos />
      <ProposicoesValores />
      <TimeMSA />
      <MarcosSucesso />
      <Footer />
    </div>
  );
}

export default SobreNosPage;
